/*
  biberna – Farb- und Größenwahl auf Produktkarten (2026-09-05, v2).

  Zusammenspiel mit snippets/card-product.liquid:
  - Jede Karte trägt data-bib-card und ein <script type="application/json"
    class="bib-card-data"> mit { colors: { "Farbe": { img, v: [[größe, id, verfügbar], ...] } } }.
  - Farbkreise (.card-swatch[data-bib-color]) wechseln das Kartenbild und
    filtern die Größen. Der Link zur Produktseite bleibt als Rückfall
    (ohne JS oder ohne Daten öffnet der Klick weiterhin die PDP).
  - Das Größen-Dropdown (select.bib-size-select) sitzt in der
    Direct-to-Cart-Zeile und setzt die Variante für den Button
    (input.product-variant-id).
  - Klick-Delegation auf document, damit auch per Facetten-Filter neu
    gerenderte Karten funktionieren.

  v2: Pills durch Dropdown ersetzt (einheitliche Position). Der Klick auf
  den Farbkreis wurde vorher vom Dawn-Overlay-Link (.card__heading a::after)
  geschluckt; gelöst per z-index in card-product.liquid.
*/
(function () {
  'use strict';

  var WIDTHS = [165, 360, 533, 720, 940];

  function data(card) {
    if (card._bibData !== undefined) return card._bibData;
    var el = card.querySelector('.bib-card-data');
    try {
      card._bibData = el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      card._bibData = null;
    }
    return card._bibData;
  }

  function cleanSize(s) {
    return String(s).replace(/1x /g, '').replace(/ cm/g, '');
  }

  function srcsetFor(url) {
    if (!url) return '';
    return WIDTHS.map(function (w) {
      return url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function swapImage(card, url) {
    if (!url) return;
    var imgs = card.querySelectorAll('.card__media .media img');
    if (!imgs.length) return;
    var set = srcsetFor(url);
    imgs.forEach(function (img) {
      img.src = url;
      img.srcset = set;
    });
  }

  function findVariant(d, color, size) {
    var c = d.colors[color];
    if (!c) return null;
    for (var i = 0; i < c.v.length; i++) {
      if (c.v[i][0] === size) return c.v[i];
    }
    return null;
  }

  function applyVariant(card, color, variant) {
    var input = card.querySelector('input.product-variant-id');
    var submit = card.querySelector('.bib-direct__submit');
    var label = card.querySelector('.bib-direct__label');
    var d = data(card);
    var multiColor = d && Object.keys(d.colors).length > 1;

    if (label) {
      var txt = variant ? cleanSize(variant[0]) : '';
      if (multiColor && color) txt = color + (txt ? ' · ' + txt : '');
      label.textContent = txt;
    }
    if (!variant) {
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('bib-direct__submit--unavailable');
      }
      return;
    }
    if (input) input.value = variant[1];
    if (submit) {
      var ok = !!variant[2];
      submit.disabled = !ok;
      submit.setAttribute('aria-disabled', ok ? 'false' : 'true');
      submit.classList.toggle('bib-direct__submit--unavailable', !ok);
      submit.title = 'In den Warenkorb – ' + (multiColor && color ? color + ', ' : '') + cleanSize(variant[0]) + (ok ? '' : ' (ausverkauft)');
    }
    card.querySelectorAll('a.full-unstyled-link, a.card-swatch.is-selected').forEach(function (a) {
      if (a.href && a.href.indexOf('/products/') !== -1) {
        a.href = a.href.split('?')[0] + '?variant=' + variant[1];
      }
    });
  }

  function selectSize(card, size) {
    var d = data(card);
    if (!d) return;
    var color = card.dataset.bibColor;
    card.dataset.bibSize = size;
    var sel = card.querySelector('.bib-size-select');
    if (sel && sel.value !== size) sel.value = size;
    applyVariant(card, color, findVariant(d, color, size));
  }

  function selectColor(card, color, keepImage) {
    var d = data(card);
    if (!d || !d.colors[color]) return;
    card.dataset.bibColor = color;

    card.querySelectorAll('.card-swatch[data-bib-color]').forEach(function (s) {
      var on = s.dataset.bibColor === color;
      s.classList.toggle('is-selected', on);
      s.setAttribute('aria-current', on ? 'true' : 'false');
    });

    if (!keepImage) swapImage(card, d.colors[color].img);

    /* Dropdown an die Farbe anpassen: fehlende Größen ausblenden,
       ausverkaufte kennzeichnen und sperren. */
    var current = card.dataset.bibSize || '';
    var firstAvailable = null;
    var currentOk = false;
    var sel = card.querySelector('.bib-size-select');
    if (sel) {
      [].forEach.call(sel.options, function (opt) {
        var v = findVariant(d, color, opt.value);
        var avail = !!(v && v[2]);
        opt.hidden = !v;
        opt.disabled = !avail;
        opt.textContent = cleanSize(opt.value) + (v && !avail ? ' – ausverkauft' : '');
        if (avail && !firstAvailable) firstAvailable = opt.value;
        if (avail && opt.value === current) currentOk = true;
      });
    } else {
      var c = d.colors[color];
      for (var i = 0; i < c.v.length; i++) {
        if (c.v[i][2]) { firstAvailable = c.v[i][0]; break; }
      }
      currentOk = !!(current && findVariant(d, color, current) && findVariant(d, color, current)[2]);
    }
    var size = currentOk ? current : (firstAvailable || current);
    if (size) selectSize(card, size);
    else applyVariant(card, color, null);
  }

  function init(card) {
    if (card._bibInit) return;
    card._bibInit = true;
    var d = data(card);
    if (!d) return;
    var input = card.querySelector('input.product-variant-id');
    var id = input ? input.value : null;
    var color = null, size = null;
    Object.keys(d.colors).some(function (c) {
      return d.colors[c].v.some(function (v) {
        if (String(v[1]) === String(id)) { color = c; size = v[0]; return true; }
        return false;
      });
    });
    if (!color) color = Object.keys(d.colors)[0];
    if (size) card.dataset.bibSize = size;
    /* v2: Das Startbild setzt Liquid serverseitig passend zur Startvariante
       (card-product.liquid, bib_card_media). Beim Laden wird deshalb kein
       Bild mehr getauscht - kein Doppel-Download, LCP bleibt unberuehrt. */
    selectColor(card, color, true);
  }

  function initAll() {
    document.querySelectorAll('[data-bib-card]').forEach(init);
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.card-swatch[data-bib-color]');
    if (!swatch) return;
    var card = swatch.closest('[data-bib-card]');
    if (card && data(card)) {
      /* 2026-09-18 (P2-17): stopPropagation() entfernt. Fuer den eigentlichen
         Zweck - die Karte darf beim Swatch-Klick nicht navigieren - genuegt
         preventDefault(): Die Default-Aktion laeuft erst NACH der kompletten
         Propagation, der Link wird also ohnehin nicht gefolgt.
         stopPropagation() bewirkte darueber hinaus nur, dass spaeter am
         document registrierte Listener den Klick nie sahen - typischerweise
         GA4, Meta Pixel und Klaviyo. Swatch-Klicks auf Produktkarten fehlten
         dadurch potenziell im Tracking. */
      e.preventDefault();
      init(card);
      selectColor(card, swatch.dataset.bibColor, false);
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.bib-size-select');
    if (!sel) return;
    var card = sel.closest('[data-bib-card]');
    if (card && data(card)) {
      init(card);
      selectSize(card, sel.value);
    }
  });

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  /* 2026-09-18 (P2-16): Der Observer rief frueher bei JEDER DOM-Aenderung
     irgendwo im Dokument initAll() auf - also alle 150 ms ein
     querySelectorAll ueber den gesamten Baum. Auf Kollektionsseiten mit
     vielen Karten und geoeffnetem Cart-Drawer (der bei jedem Rendern den
     halben Teilbaum ersetzt) ist das eine dauerhafte Last.

     Der Observer bleibt noetig - Karten kommen per Pagination, Filter und
     Cross-Sell nach. Er sammelt jetzt aber nur die tatsaechlich neu
     eingefuegten Karten ein. init() hat weiterhin seinen _bibInit-Schutz. */
  var pending = null;
  var warteschlange = [];

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-bib-card]')) warteschlange.push(node);
        if (node.querySelectorAll) {
          var innen = node.querySelectorAll('[data-bib-card]');
          for (var k = 0; k < innen.length; k++) warteschlange.push(innen[k]);
        }
      }
    }

    if (!warteschlange.length || pending) return;

    pending = setTimeout(function () {
      pending = null;
      var offen = warteschlange;
      warteschlange = [];
      offen.forEach(init);
    }, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
